/** Durée d’un tour de jeu en replay (ms) — slider + localStorage. */
export const ARCHIVE_ROUND_MS_STORAGE_KEY = 'multirx-archive-round-ms';
export const ARCHIVE_ROUND_MS_DEFAULT = 800;
export const ARCHIVE_ROUND_MS_MIN = 200;
export const ARCHIVE_ROUND_MS_MAX = 2000;

export function clampArchiveRoundMs(ms: number): number {
  if (!Number.isFinite(ms)) return ARCHIVE_ROUND_MS_DEFAULT;
  return Math.min(ARCHIVE_ROUND_MS_MAX, Math.max(ARCHIVE_ROUND_MS_MIN, Math.round(ms)));
}

export function readArchiveRoundMs(storage: Pick<Storage, 'getItem'> = localStorage): number {
  const raw = storage.getItem(ARCHIVE_ROUND_MS_STORAGE_KEY);
  if (raw == null || raw === '') return ARCHIVE_ROUND_MS_DEFAULT;
  return clampArchiveRoundMs(Number(raw));
}

export function writeArchiveRoundMs(
  ms: number,
  storage: Pick<Storage, 'setItem'> = localStorage
): number {
  const clamped = clampArchiveRoundMs(ms);
  storage.setItem(ARCHIVE_ROUND_MS_STORAGE_KEY, String(clamped));
  return clamped;
}

/**
 * Nombre de cases représenté par la durée du slider (dé « typique »).
 * Un trajet plus long (tour joker) allonge le tour — pas de compression / TP.
 */
export const ARCHIVE_ROUND_REFERENCE_SEGMENTS = 5;

/**
 * Durée d’un tour de replay à partir du trajet le plus long :
 * `roundDurationMs` ≈ temps pour {@link ARCHIVE_ROUND_REFERENCE_SEGMENTS} cases.
 * Tous les pions du tour partagent cette durée (pas d’arrêt des trajets courts).
 */
export function archivePathDurationMs(roundDurationMs: number, pathSegments: number): number {
  const segs = Math.max(1, Math.floor(pathSegments));
  const base =
    Number.isFinite(roundDurationMs) && roundDurationMs > 0
      ? roundDurationMs
      : ARCHIVE_ROUND_MS_DEFAULT;
  return Math.max(1, Math.round((base * segs) / ARCHIVE_ROUND_REFERENCE_SEGMENTS));
}
